module.exports = __webpack_public_path__ + "img/ShaderEditorFollowMouse.dbf5bef4.gif";